<template>
<div class="main_content">
  <div class="center">您确定要删除任务“{{curItem.taskName}}”吗？</div>
</div>
</template>

<script>
  export default {
    props: ['curItem']
  }
</script>

<style lang="scss" scoped>
.main_content {
  background: #fff;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .center {
    text-align: center;
    line-height: 20px;
    width: 300px;
    margin: 0 auto;
  }
}
</style>
